import HttpRequest from './httpRequest'

export default class AuthProvider extends HttpRequest {
  login (params) {
    return this.create('/auth/login', params)
  }

  chooseLineAccount (params) {
    return this.create('/auth/choose-line-account', params)
  }
}
